export default function H4({ title, fontWeight = 'normal', theme = "title", underline = false, className = "" }) {
    return (
        <h4 className={`text-md md:text-lg font-${fontWeight} text-${theme} ${underline ? "underline" : ""} ${className}`}>
            {title}
        </h4>
    );
}
